import type { IStudentUserInfo } from "~/domain/user-session"

/**
 * Возвращает информацию о студенте из локального хранилища
 */
export function getStudentUserInfo(): IStudentUserInfo | null {
	const studentUserInfo = localStorage.getItem("paUserInfo")
	return studentUserInfo && JSON.parse(studentUserInfo)
}
